import Grid from "@/components/Grid";
import SearchNoResults from "@/components/SearchNoResults";
import {
  useSearchConfigQuery,
  useSearchEpisodeLazyQuery,
  useSearchTvShowLazyQuery,
} from "@/hooks";
import config, { getStoreId } from "@/lib/config";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import { useEffect, useMemo } from "react";

export default function SearchResult({ mode, searchQuery, sort }) {
  const res = useSearchConfigQuery({ fetchPolicy: "cache-first" });
  const searchConfig = res?.data?.searchConfig;
  const hitWords = searchConfig?.keywordMinScore?.filter((keywordWithScore) => {
    const { keyword } = keywordWithScore;
    return keyword === searchQuery;
  });

  const minScoreValue =
    hitWords?.length > 0 ? hitWords[0]?.score : searchConfig?.defaultMinScore;
  const minScore = minScoreValue;

  const [
    searchEpisode,
    { data: episodeData, ...episodeResult },
  ] = useSearchEpisodeLazyQuery({
    nextFetchPolicy: "cache-first",
  });
  const [
    searchTvshow,
    { data: tvshowData, ...tvshowResult },
  ] = useSearchTvShowLazyQuery({
    nextFetchPolicy: "cache-first",
  });
  const items = useMemo(() => {
    if (mode === "valueplan") {
      return tvshowData?.search;
    } else {
      return episodeData?.search;
    }
  }, [mode, episodeData, tvshowData]);

  const result = useMemo(() => {
    if (mode === "valueplan") {
      return tvshowResult;
    } else {
      return episodeResult;
    }
  }, [mode, episodeResult, tvshowResult]);

  useEffect(() => {
    const validMode = ["valueplan", "channel", "store", "live"];
    if (validMode.includes(mode) && searchQuery && sort) {
      const storeId = getStoreId();
      const valuePlanId = config.valuePlanId.vod;
      const variables = {
        keyword: searchQuery,
        sort,
        offset: 0,
        limit: GRID_PAGE_LIMIT,
        minScore,
      };
      if (mode === "channel") {
        variables.filter = {
          not: { "values.channel": [storeId, valuePlanId] },
          // "values.packages_type": PACKAGE_TYPE.svod,
        };
        searchEpisode({ variables });
      } else if (mode === "store") {
        variables.filter = {
          "values.channel": storeId,
          // "values.packages_type": PACKAGE_TYPE.tvod,
        };
        searchEpisode({ variables });
      } else if (mode === "valueplan") {
        variables.filter = {
          "values.channel": config.valuePlanId.vod,
        };
        searchTvshow({ variables });
      } else if (mode === "live") {
        variables.filter = {
          "values.is_live": true,
          time_range: { "values.encode_end_date": { gte: "now" } },
        };
        searchEpisode({ variables });
      }
    }
  }, [mode, searchQuery, sort]);

  return (
    <Grid
      key={`search-result-${mode}`}
      items={items}
      {...result}
      limit={GRID_PAGE_LIMIT}
      noContent={<SearchNoResults searchQuery={searchQuery} />}
    />
  );
}
